export const numberListAnimation = (() => {
    document.addEventListener("DOMContentLoaded", () => {
        const counters = document.querySelectorAll(".js-count-up");

        counters.forEach(counter => {
            const target = parseInt(counter.textContent, 10);
            if (isNaN(target) || target <= 0) return;
            let speed = 40;
            let increase = 1;

            if (target > 1000 && target < 10000) { speed = 20; increase = 10; }
            else if (target > 10000 && target < 50000) { speed = 10; increase = 100 }
            else if (target > 50000) { speed = 5; increase = 1000 }

            const duration = 2500; // in ms
            const startTime = performance.now();

            const animate = (currentTime) => {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                let value = Math.floor(progress * target);

                if (increase > 1) {
                    value = Math.min(Math.ceil(value / increase) * increase, target);
                }

                counter.textContent = value.toLocaleString(); // formatted with commas

                if (progress < 1) {
                    requestAnimationFrame(animate);
                } else {
                    counter.textContent = target.toLocaleString();
                }
            };

            counter.textContent = "0";
            requestAnimationFrame(animate);
        });
    });
})();
